<template>
  <section>
    <yn-with-title :title="'Welcome!'">
      <div>
        Need to prepare a dataset for your binary classifier machine learning model? Your labels are as simple as True
        (that is “Yas” in our vocabulary) and False (that is “Nah” as we say it)? There is no simpler way – upload your
        questions and contexts, invite your annotators and let it stew for a bit. We will notify you when it has cooked
        through well enough and your dataset is ready for download. That’s it! Finite! Done!
      </div>
    </yn-with-title>

    <br />
    <div>
      You can create a new topic with a sample dataset to get started.
    </div>
    <br />
    <div>
      <yn-button color="primary" :disabled="isCreateSampleRequestPending" @click="createSample"
        >Create a sample</yn-button
      >
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Button from '@/components/common/Button';
import WithTitle from './../common/_WithTitle';

export default {
  components: {
    'yn-button': Button,
    'yn-with-title': WithTitle
  },
  computed: {
    ...mapState({
      isCreateSampleRequestPending: s => s.onboarding.isCreateSampleRequestPending,
      isCreateSampleRequestFailed: s => s.onboarding.isCreateSampleRequestFailed
    })
  },
  methods: {
    async createSample() {
      try {
        const [{ id }, tasks] = await this.$store.dispatch('onboarding/createSample');
        this.$toast.success({
          title: 'Sample topic created',
          message: `${tasks.length} tasks were added`
        });
        this.$router.push({ path: `/topics/${id}` });
      } catch (e) {
        this.$toast.error({
          title: 'Import failed',
          message: `Please, try again later or contact our development team.`
        });
      }
    }
  }
};
</script>
